import { ShieldAlert, LogOut } from 'lucide-react';
import { supabase } from '../../lib/supabase';

interface AdminLoginScreenProps {
    isUnauthorized: boolean;
}

export const AdminLoginScreen = ({ isUnauthorized }: AdminLoginScreenProps) => {
    const handleAuth = async () => {
        const { error } = await supabase.auth.signInWithOAuth({
            provider: 'google',
            options: {
                redirectTo: window.location.href
            }
        });
        if (error) console.error(error);
    };

    const handleLogout = async () => {
        await supabase.auth.signOut();
        window.location.reload();
    };

    return (
        <div className="min-h-screen bg-scrim text-danger font-mono flex flex-col items-center justify-center p-4">
            <div className="max-w-md w-full border border-danger/30 bg-danger/5 p-8 rounded-lg text-center relative overflow-hidden">
                {/* Scanlines Effect */}
                <div className="absolute inset-0 pointer-events-none opacity-10"
                    style={{ backgroundImage: 'linear-gradient(rgba(18, 16, 16, 0) 50%, rgba(0, 0, 0, 0.25) 50%), linear-gradient(90deg, rgba(255, 0, 0, 0.06), rgba(255, 0, 0, 0.02), rgba(255, 0, 0, 0.06))', backgroundSize: '100% 2px, 3px 100%' }}
                />

                <div className="relative z-10 flex flex-col items-center gap-6">
                    <div className={`p-4 rounded-full border ${isUnauthorized ? 'bg-danger/20 border-danger animate-none' : 'bg-danger/10 border-danger/20 animate-pulse'}`}>
                        <ShieldAlert className="w-16 h-16" />
                    </div>

                    <h1 className="text-3xl font-bold tracking-widest uppercase text-danger drop-shadow-[0_0_10px_color-mix(in_oklab,var(--fd-danger)_50%,transparent)]">
                        {isUnauthorized ? 'ACCESS DENIED' : 'FORGEDASH CONTROL TOWER'}
                    </h1>
                    <p className="text-danger/70 text-sm tracking-widest uppercase">
                        {isUnauthorized ? 'BIOMETRICS REJECTED // INVALID USER' : 'SYSTEM AUTHORISATION REQUIRED'}
                    </p>

                    <div className="h-px w-full bg-gradient-to-r from-transparent via-danger/15 to-transparent" />

                    <div className="space-y-4 text-xs tracking-wider text-danger/50">
                        <p>AUTHORISED PERSONNEL ONLY</p>
                        <p>ACCESS LOGGED AND MONITORED</p>
                        <p>IP ADDRESS: {window.location.hostname}</p>
                    </div>

                    {isUnauthorized ? (
                        <button
                            onClick={handleLogout}
                            className="mt-8 px-6 py-2 border border-danger/30 text-danger hover:bg-danger/10 transition-colors bg-transparent uppercase tracking-widest text-xs cursor-pointer flex items-center gap-2"
                        >
                            <LogOut className="w-4 h-4" />
                            Sign Out
                        </button>
                    ) : (
                        <button
                            onClick={handleAuth}
                            className="mt-8 px-6 py-2 border border-danger/30 text-danger hover:bg-danger/10 transition-colors bg-transparent uppercase tracking-widest text-xs cursor-pointer"
                        >
                            Authenticate Identity
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};
